// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");
var ToggleInput$ReactHooksTemplate = require("../common/ToggleInput.res.js");
var CheckboxInput$ReactHooksTemplate = require("../common/CheckboxInput.res.js");
var ImportEnrichment$ReactHooksTemplate = require("./importEnrichment.res.js");
var ConfigurationSettingCard$ReactHooksTemplate = require("../common/ConfigurationSettingCard.res.js");

function ImportEnrichments(props) {
  var __compact = props.compact;
  var __campaignScope = props.campaignScope;
  var onChange = props.onChange;
  var enforced = props.enforced;
  var enforce = props.enforce;
  var setting = props.setting;
  var campaignScope = __campaignScope !== undefined ? __campaignScope : false;
  var compact = __compact !== undefined ? __compact : false;
  var value = ImportEnrichment$ReactHooksTemplate.value(setting);
  var toggleValue = function (param) {
    Curry._2(onChange, {
          TAG: "ImportEnrichment",
          _0: ImportEnrichment$ReactHooksTemplate.setValue(setting, !value)
        }, enforce);
  };
  var campaignDescription = "Enable import enrichment for this campaign's feed imports and survey trigger payloads. When enabled, tenant-wide rules from General Settings run first, then this campaign's rules.";
  var organizationDescription = "When enabled, tenant-wide import enrichment rules run for all campaigns. Disable to hide tenant-wide rules and stop organization-level evaluation.";
  if (compact) {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("h3", {
                                                children: "Import Enrichment",
                                                className: ConfigurationSettingCard$ReactHooksTemplate.titleClass(value)
                                              }),
                                          JsxRuntime.jsx(ConfigurationSettingCard$ReactHooksTemplate.statusBadge, {
                                                enabled: value
                                              })
                                        ],
                                        className: "flex items-center gap-2 flex-wrap"
                                      }),
                                  JsxRuntime.jsx("p", {
                                        children: campaignScope ? campaignDescription : organizationDescription,
                                        className: ConfigurationSettingCard$ReactHooksTemplate.descriptionClass(value)
                                      })
                                ],
                                className: "min-w-0"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(ToggleInput$ReactHooksTemplate.make, {
                                      checked: value,
                                      disabled: enforced,
                                      handleChange: (function (param) {
                                          if (enforced) {
                                            return ;
                                          } else {
                                            return toggleValue();
                                          }
                                        }),
                                      labelClassName: "flex items-center"
                                    }),
                                className: "flex-shrink-0"
                              })
                        ],
                        className: "flex items-start justify-between gap-3"
                      }),
                  campaignScope ? null : JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                checked: enforce,
                                disabled: enforced,
                                label: "Enforce Policy",
                                handleChange: (function (param) {
                                    if (!enforced) {
                                      return Curry._2(onChange, {
                                                  TAG: "ImportEnrichment",
                                                  _0: setting
                                                }, !enforce);
                                    }
                                    
                                  }),
                                checkboxClassName: "custom_checkbox",
                                labelClassName: "text-xs font-medium text-darkcharcoal"
                              }),
                          className: "mt-3 pt-3 border-t border-gray-200"
                        }),
                  enforced ? JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("span", {
                                  children: "🔒"
                                }),
                            JsxRuntime.jsx("span", {
                                  children: "Enforced by administrator"
                                })
                          ],
                          className: "mt-3 flex items-center gap-1.5 text-xs text-aurometalsaurus"
                        }) : null
                ],
                className: ConfigurationSettingCard$ReactHooksTemplate.compactCardClass(enforced, value)
              });
  } else {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("span", {
                                        children: "🧬",
                                        className: "text-lg"
                                      }),
                                  JsxRuntime.jsx("h2", {
                                        children: "Import Enrichment",
                                        className: "text-lg font-bold text-gray-900"
                                      }),
                                  enforced ? JsxRuntime.jsx("span", {
                                          children: "🔒 Enforced",
                                          className: "text-xs font-medium text-blue-700 bg-blue-100 px-2 py-1 rounded-full"
                                        }) : null
                                ],
                                className: "flex items-center space-x-2"
                              }),
                          JsxRuntime.jsx("p", {
                                children: campaignScope ? campaignDescription : organizationDescription,
                                className: "text-sm text-gray-600 mt-1"
                              })
                        ],
                        className: "bg-gradient-to-r from-emerald-50 to-teal-50 px-6 py-4 border-b border-gray-200"
                      }),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx(ToggleInput$ReactHooksTemplate.make, {
                                                                checked: value,
                                                                disabled: enforced,
                                                                handleChange: (function (param) {
                                                                    if (enforced) {
                                                                      return ;
                                                                    } else {
                                                                      return toggleValue();
                                                                    }
                                                                  }),
                                                                labelClassName: "flex items-center"
                                                              }),
                                                          JsxRuntime.jsx("span", {
                                                                children: "Enable Import Enrichment",
                                                                className: "text-sm font-medium text-gray-700"
                                                              })
                                                        ],
                                                        className: "flex items-center space-x-2"
                                                      }),
                                                  value ? JsxRuntime.jsx("span", {
                                                          children: "Active",
                                                          className: "inline-flex items-center px-2 py-1 text-xs font-medium text-green-700 bg-green-100 rounded-full"
                                                        }) : JsxRuntime.jsx("span", {
                                                          children: "Disabled",
                                                          className: "inline-flex items-center px-2 py-1 text-xs font-medium text-gray-500 bg-gray-100 rounded-full"
                                                        })
                                                ],
                                                className: "flex items-center space-x-3"
                                              }),
                                          campaignScope ? null : JsxRuntime.jsx("p", {
                                                  children: "When disabled, tenant-wide import enrichment rules are not evaluated. Rule definitions remain saved in Settings → Import Enrichment Rules.",
                                                  className: "text-xs text-gray-500 mt-2"
                                                })
                                        ],
                                        className: "flex-1"
                                      }),
                                  campaignScope ? null : JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                                        checked: enforce,
                                                        disabled: enforced,
                                                        label: "Enforce Policy",
                                                        handleChange: (function (param) {
                                                            if (!enforced) {
                                                              return Curry._2(onChange, {
                                                                          TAG: "ImportEnrichment",
                                                                          _0: setting
                                                                        }, !enforce);
                                                            }
                                                            
                                                          }),
                                                        checkboxClassName: "custom_checkbox"
                                                      }),
                                                  enforce ? JsxRuntime.jsx("span", {
                                                          children: "🔒",
                                                          className: "text-xs font-medium text-blue-700"
                                                        }) : null
                                                ],
                                                className: "flex items-center space-x-2 px-4 py-2 rounded-lg " + (
                                                  enforce ? "bg-blue-100 border border-blue-200" : "bg-white border border-gray-200"
                                                )
                                              }),
                                          className: "ml-6"
                                        })
                                ],
                                className: "flex items-center justify-between"
                              }),
                          enforced ? JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("span", {
                                                children: "⚠️",
                                                className: "text-sm"
                                              }),
                                          JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx("p", {
                                                      children: "This setting is enforced and cannot be modified",
                                                      className: "text-xs font-medium text-yellow-900"
                                                    })
                                              })
                                        ],
                                        className: "flex items-start space-x-2"
                                      }),
                                  className: "mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg"
                                }) : null
                        ],
                        className: "p-6"
                      })
                ]
              });
  }
}

var make = ImportEnrichments;

exports.make = make;
/* react/jsx-runtime Not a pure module */
